module.exports = __webpack_public_path__ + "img/12.328fd675.png";